import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'


const BASE_URL = baseUrl + '/auth'

export default {

    //登录发送验证码
    mCode(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/mCode',
            method: 'get',
            params
        })
    },
    //验证码登录
    mobilelogin(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/mlogin',
            method: 'get',
            params
        })
    }
}